import { createMachine } from "xstate";

export const approveMachine = createMachine(
  {
    id: "PERMIT2",
    initial: "HAS_EXISTING_APPROVAL",
    states: {
      HAS_EXISTING_APPROVAL: {
        on: {
          ON_HAS_EXISTING_APPROVAL: {
            target: "IS_APPROVAL_SUFFICIENT",
          },
          ON_INSUFFICIENT_APPROVAL: {
            target: "APPROVE",
          },
        },
      },
      IS_APPROVAL_SUFFICIENT: {
        on: {
          ON_SUFFICIENT_APPROVAL: {
            target: "DONE",
          },
          ON_INSUFFICIENT_APPROVAL: {
            target: "IS_REVOKE_FIRST_TOKEN",
          },
        },
      },
      APPROVE: {
        initial: "PENDING_APPROVAL",
        states: {
          PENDING_APPROVAL: {
            on: {
              ON_APPROVAL_START: {
                target: "CONFIRM_IN_WALLET",
              },
            },
          },
          CONFIRM_IN_WALLET: {
            on: {
              ON_CONFIRM: {
                target: "WAITING_FOR_TX",
              },
              ON_APPROVAL_REJECT: {
                target: "RETRY_APPROVE",
              },
            },
          },
          WAITING_FOR_TX: {
            on: {
              ON_TX_RECIEPT: {
                target: "TX_CONFIRMED",
              },
              ON_TX_FAIL: {
                target: "RETRY_APPROVE",
              },
            },
          },
          RETRY_APPROVE: {
            on: {
              ON_RETRY: {
                target: "CONFIRM_IN_WALLET",
              },
            },
          },
          TX_CONFIRMED: {
            on: {
              ON_APPROVED: {
                target: "#PERMIT2.IS_REAPPROVED_AMOUNT_SUFFICIENT",
              },
            },
          },
        },
      },
      DONE: {
        type: "final",
      },
      IS_REVOKE_FIRST_TOKEN: {
        on: {
          ON_IS_REVOKE_FIRST: {
            target: "REVOKE",
          },
          ON_IS_NOT_REVOKE_FIRST: {
            target: "APPROVE",
          },
        },
      },
      REVOKE: {
        initial: "PENDING_REVOKE",
        states: {
          PENDING_REVOKE: {
            on: {
              ON_REVOKE_START: {
                target: "CONFIRM_IN_WALLET",
              },
            },
          },
          CONFIRM_IN_WALLET: {
            on: {
              ON_REVOKE_CONFIRM: {
                target: "WAITING_FOR_TX",
              },
              ON_REVOKE_REJECT: {
                target: "RETRY_REVOKE",
              },
            },
          },
          WAITING_FOR_TX: {
            on: {
              ON_TX_RECEIPT: {
                target: "REVOKE_TX_CONFRIMED",
              },
              ON_REVOKE_TX_FAIL: {
                target: "RETRY_REVOKE",
              },
            },
          },
          RETRY_REVOKE: {
            on: {
              ON_RETRY_REVOKE: {
                target: "CONFIRM_IN_WALLET",
              },
            },
          },
          REVOKE_TX_CONFRIMED: {
            on: {
              ON_REVOKED: {
                target: "#PERMIT2.APPROVE",
              },
            },
          },
        },
      },
      IS_REAPPROVED_AMOUNT_SUFFICIENT: {
        on: {
          ON_SUFFICIENT_AMOUNT: {
            target: "DONE",
          },
          ON_INSUFFICIENT_APPROVAL: {
            target: "CUSTOM_APPROVALS",
          },
        },
      },
      CUSTOM_APPROVALS: {
        on: {
          ON_RESTART: {
            target: "IS_REVOKE_FIRST_TOKEN",
          },
        },
      },
    },
    schema: {
      events: {} as
        | { type: "ON_CONFIRM" }
        | { type: "ON_TX_FAIL" }
        | { type: "ON_TX_RECIEPT" }
        | { type: "ON_SUFFICIENT_AMOUNT" }
        | { type: "ON_APPROVED" }
        | { type: "" }
        | { type: "ON_REVOKED" }
        | { type: "ON_IS_REVOKE_FIRST" }
        | { type: "ON_HAS_EXISTING_APPROVAL" }
        | { type: "ON_TX_RECEIPT" }
        | { type: "ON_REVOKE_CONFIRM" }
        | { type: "ON_REVOKE_TX_FAIL" }
        | { type: "ON_RETRY_REVOKE" }
        | { type: "ON_IS_NOT_REVOKE_FIRST" }
        | { type: "ON_REVOKE_START" }
        | { type: "ON_INSUFFICIENT_APPROVAL" }
        | { type: "ON_APPROVAL_START" }
        | { type: "ON_SUFFICIENT_APPROVAL" }
        | { type: "ON_REVOKE_REJECT" }
        | { type: "ON_APPROVAL_REJECT" }
        | { type: "ON_RETRY" }
        | { type: "ON_RESTART" },
    },
    predictableActionArguments: true,
    preserveActionOrder: true,
  },
  {
    actions: {},
    services: {},
    guards: {},
    delays: {},
  }
);
